import { Injectable } from '@angular/core';

function _window(): any {
  return window;
}

export type RazorpayCheckoutCallbacks = {
  onSuccess?: (response: Record<string, unknown>) => void;
  onDismiss?: () => void;
  onFailure?: (error: Record<string, unknown>) => void;
};

@Injectable({
  providedIn: 'root'
})
export class WindowRefService {

  private razorpayLoaded = false;

  constructor() { }

  get nativeWindow(): any {
    return _window();
  }

  private loadRazorpayScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.razorpayLoaded || this.nativeWindow.Razorpay) {
        this.razorpayLoaded = true;
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        this.razorpayLoaded = true;
        resolve();
      };
      script.onerror = () => reject(new Error('Failed to load Razorpay script'));
      document.body.appendChild(script);
    });
  }

  payWithRazor(
    username,
    email,
    contact,
    order_id,
    amount,
    callback_url,
    currency,
    key,
    auto_renew,
    callbacks?: RazorpayCheckoutCallbacks
  ) {
    this.loadRazorpayScript().then(() => {
      const useHandler = !!(callbacks?.onSuccess || callbacks?.onDismiss || callbacks?.onFailure);
      const options: any = {
        key,
        amount,
        currency,
        name: 'Supersee',
        description: 'SuperSee seat subscription',
        image: 'https://i.ibb.co/zZ11XS2/image.png',
        prefill: {
          name: username,
          email,
          contact
        },
        notes: {
          address: 'Rao information technology Office'
        },
        theme: {
          color: '#5459d1'
        },
        modal: {
          ondismiss: () => {
            callbacks?.onDismiss?.();
          }
        }
      };

      if (auto_renew) {
        options.subscription_id = order_id;
      } else {
        options.order_id = order_id;
      }

      if (useHandler) {
        // Prefer in-page handler so Billing can show success/failure without a blind redirect.
        // After success we still send the browser to callback_url so WP can finalize the order.
        options.handler = (response: Record<string, unknown>) => {
          callbacks?.onSuccess?.(response || {});
          if (callback_url) {
            try {
              const url = new URL(callback_url, this.nativeWindow.location.href);
              Object.keys(response || {}).forEach((k) => {
                const v = response[k];
                if (v != null) {
                  url.searchParams.set(k, String(v));
                }
              });
              // Short delay so the success state can paint before redirect.
              setTimeout(() => {
                this.nativeWindow.location.href = url.toString();
              }, 900);
            } catch {
              this.nativeWindow.location.href = callback_url;
            }
          }
        };
      } else if (callback_url) {
        options.callback_url = callback_url;
      }

      const rzp = new this.nativeWindow.Razorpay(options);
      if (callbacks?.onFailure) {
        rzp.on('payment.failed', (response: any) => {
          callbacks.onFailure?.(response?.error || response || {});
        });
      }
      rzp.open();
    }).catch(error => {
      console.error('Failed to load Razorpay:', error);
      callbacks?.onFailure?.({ description: 'Failed to load Razorpay checkout' });
    });
  }
}
